import React, {useCallback, useMemo} from 'react';
import {useForm, useFormState} from 'react-final-form';
import cn from 'classnames';

import {useLanguageDirection} from 'coreHooks';

import Dropdown from 'brandComponents/Dropdown';
import {EDropdownDirection} from 'brandComponents/Dropdown/IDropdown';
import Field from 'brandComponents/Form/Subcomponents/Field';
import Icon from 'brandComponents/Icon';

import {IDropdownSelectFields} from './IDropdownSelect';

import styles from './DropdownSelect.module.scss';

const DropdownSelect = (
	{
		label,
		requirednessLabel,
		disabled,
		name,
		data
	} : IDropdownSelectFields) => {
	const form = useForm();
	const formState = useFormState();
	const initialValue = formState.initialValues[name];
	const value = formState.values[name] || initialValue;
	const selectedOption = useMemo(() => data.find((i) => i.value === value), [value, data]);
	const isRTL = useLanguageDirection().direction === 'rtl';
	const changeValue = useCallback((value) => {
		form.change(name, value);
	}, []);

	return (
		<>
			<div className={cn(styles['dropdown-select-field'], 'dropdown-select-field')}>
				<span
					className={cn(styles['dropdown-select-label'],
						{
							[styles['dropdown-select-label-disabled']]: disabled
						})}>
					{label}{requirednessLabel}
				</span>
				<Dropdown
					label={label}
					classNames={cn({'not-selected':!selectedOption})}
					value={selectedOption?.label}
					direction={EDropdownDirection.DYNAMIC}
					disabled={disabled}
				>
					<Dropdown.Trigger
						customIcon={<Icon name="arrow-down" width={20} height={20} />}
					/>
					<Dropdown.Menu
						data={data}
						onSelect={changeValue}
						classNames={isRTL ? 'dropdown__menu--reversed' : ''}
						searchable
					/>
				</Dropdown>
			</div>
			<Field name={name} component="input" type="hidden" />
		</>
	);
};

export default DropdownSelect;
